/* import __COLOCATED_TEMPLATE__ from './detect-categories.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: { accordion: $TSFixMe; categoriesCount: number };
}

const DetectCategories = templateOnlyComponent<Signature>();
export default DetectCategories;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::DetectCategories': typeof DetectCategories;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/detect-categories': typeof DetectCategories;
  }
}
